import {useProfile} from "../../UserProfileProvider";
import {useEffect, useState} from "react";
import {SaveCancelEditButtons} from "../../util/UI/SaveCancelEditButtons";
import {useUpdateUserProfileRpc} from "../../util/RpcHooks/UpdateUserProfile";
import {UpdateUserProfileRequest} from "../../compiled";
import {EditableContext} from "../../components/Editable/EditableContext";
import {EditableStringField} from "../../components/Editable/EditableStringField";
import {EditableVerifiedEmailField} from "../../components/Editable/EditableVerifiedEmailField";
import {EditableVerifiedPhoneInputField} from "../../components/Editable/EditableVerifiedPhoneInputField";

export const AccountSettingsProfileBox = () => {

  const updateUserProfileRpc = useUpdateUserProfileRpc();

  const {profile, profileLoading, profileError} = useProfile();

  const [editing, setIsEditing] = useState(false);

  /**
   * These are the fields that are displayed and edited in the contact information box.
   * The ApiUserProto contains other fields that aren't editable. 
   */
  type EditableType = {
    firstName: string | null | undefined;
    lastName: string | null | undefined;
    contactEmail: string | null | undefined;
    mobileNumber: string | null | undefined;
  }

  const [workingCopy, setWorkingCopy] = useState<EditableType>({
    lastName: undefined,
    firstName: undefined,
    contactEmail: undefined,
    mobileNumber: undefined,
  });

  useEffect(() => {
    updateFromProfile();
  }, [profile])

  const updateFromProfile = () => {
    setWorkingCopy({
      firstName: profile?.givenName,
      lastName: profile?.familyName,
      contactEmail: profile?.contactEmail,
      mobileNumber: profile?.mobileNumber,
    })
  }

  const sendUpdateRpc = () => {
    updateUserProfileRpc.send(new UpdateUserProfileRequest({
      contactEmail: workingCopy?.contactEmail,
      firstName: workingCopy?.firstName,
      lastName: workingCopy?.lastName,
      mobileNumber: workingCopy?.mobileNumber,
    }), () => setIsEditing(false) /* onSuccess callback turns off editing */)
  }

  return <div className={'AccountSettingsBox'}>
    <div className={'AccountSettingsHeader'}>
      <div>CONTACT INFORMATION</div>
      <div style={{flex: 1, justifyItems: 'flex-end'}}>
        <SaveCancelEditButtons isEditing={editing} rpcState={updateUserProfileRpc.rpcState}
                               onEdit={() => setIsEditing(true)}
                               onCancel={() => {
                                 updateFromProfile();
                                 updateUserProfileRpc.reset();
                                 setIsEditing(false)
                               }}
                               onSave={sendUpdateRpc}/>
      </div>
    </div>


    {profileLoading && <div>Loading...</div>}

    {profileError && <div className={'ErrorText'}>Error loading your profile.</div>}

    {!profileLoading && !profileError && <EditableContext.Provider value={{
      editing: editing,
      errors: updateUserProfileRpc.errors,
      workingCopy: workingCopy,
      setWorkingCopy: setWorkingCopy,
      mode: 'update'
    }}>

      <EditableStringField<EditableType>
          label={'First name'}
          inputType={'text'}
          field={'firstName'}
      />

      <EditableStringField<EditableType>
          label={'Last name'}
          inputType={'text'}
          field={'lastName'}
      />

      <EditableVerifiedEmailField<EditableType>
          label={'Contact email'}
          field={'contactEmail'}
      />

      <EditableVerifiedPhoneInputField<EditableType>
          label={'Mobile number'}
          field={'mobileNumber'}
      />

      {updateUserProfileRpc.rpcState.state === 'error' &&
          !updateUserProfileRpc.errors.length && // only show if there aren't field errors
          <div className={'ErrorText'}>Error updating your profile. Please try again later</div>}

    </EditableContext.Provider>
    }

  </div>
}